module.exports = __webpack_public_path__ + "./docs/img/icon-open-in-new.cd7e1b6d5cc8a876e9d748aba4e6f3cd.svg";